import { IsBoolean, IsDecimal, IsNumberString } from "class-validator";

export class GiftCardTransactionRefundResponse {
    constructor(
        cardNumber: string,
        balance: number,
        previousBalance: number,
        refundAmount: number,
        success: boolean,
        reference: number
      ) {
        this.cardNumber = cardNumber;
        this.balance = balance;
        this.previousBalance = previousBalance;
        this.refundAmount = refundAmount;
        this.success = success;
        this.reference = reference;
      }
    
      cardNumber: string;
    
      @IsDecimal()
      balance: number;
    
      @IsDecimal()
      previousBalance: number;
    
      @IsDecimal()
      refundAmount: number;
    
      @IsBoolean()
      success: boolean;
    
      @IsDecimal()
      reference: number;
}